var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_974_5440)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_974_5440)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0249 3.07678C13.2398 3.00523 13.4682 2.9833 13.6928 3.01262C13.9174 3.04194 14.1325 3.12175 14.3218 3.24607C14.5112 3.37039 14.67 3.53599 14.7862 3.73043C14.9024 3.92488 14.9731 4.14312 14.9929 4.36878L14.9989 4.50078V9.98678L18.7929 10.7468C19.1091 10.8098 19.3965 10.973 19.6127 11.2122C19.8288 11.4514 19.9621 11.7539 19.9929 12.0748L19.9989 12.2168V19.8068H20.9989C21.2538 19.8071 21.4989 19.9047 21.6843 20.0796C21.8696 20.2546 21.9811 20.4937 21.9961 20.7482C22.011 21.0026 21.9282 21.2532 21.7646 21.4486C21.601 21.6441 21.369 21.7697 21.1159 21.7998L20.9989 21.8068H2.99889C2.74401 21.8065 2.49886 21.7089 2.31352 21.5339C2.12819 21.359 2.01666 21.1198 2.00172 20.8654C1.98678 20.6109 2.06957 20.3604 2.23316 20.1649C2.39675 19.9695 2.6288 19.8439 2.88189 19.8138L2.99889 19.8068H3.99889V7.16678C3.99889 6.56678 4.35489 6.03078 4.89689 5.79278L5.02489 5.74378L13.0249 3.07678ZM12.9989 5.19478L5.99889 7.52778V19.8068H12.9989V5.19478ZM14.9989 12.0278V19.8068H17.9989V12.6268L14.9989 12.0278Z",
    fill: "#667085"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_974_5440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_974_5440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectSidebar);
export default __webpack_public_path__ + "static/media/projectSidebar.3ffc830d88d3173e27330af5b86ebc85.svg";
export { ForwardRef as ReactComponent };